<div *ngIf="type=='InDetail'">
  <div id="print-section" style="margin-top: 50px;margin-left: 5px;">
    <table class="table table-bordered">
      <thead>
        <tr>
          <th colspan="21"
            style="border: 0px solid #ffffff;border-bottom: 2px solid #7e7b7b;border-top: 2px solid #7e7b7b;border-left: 2px solid #7e7b7b;font-size: 15px; text-align: center; padding: 5px;width:0%;">
            <span style="text-align:center;">Advt Registration Report - Indetail</span>
          </th>
        </tr>
        <tr>
          <th colspan="6"
            style="border: 0px solid #ffffff;border-bottom: 2px solid #7e7b7b;border-top: 2px solid #7e7b7b;border-left: 2px solid #7e7b7b;font-size: 15px; text-align: left; padding: 5px;width:0%;">
            <span style="text-align:center;">हिंदुस्तान प्रकाशन संस्था-विवेक साप्ताहिक</span>
          </th>
          <th colspan="5"
            style="border: 0px solid #fdfdfd;border-bottom: 2px solid #7e7b7b;border-top: 2px solid #7e7b7b;font-size: 15px;text-align: left; padding: 5px;width:0%;border-right: 2px solid #7e7b7b;">
            <span style="text-align:center;"><span><strong>अंकाचे कॅटेगरी :</strong> &nbsp; {{issue_cat}} </span></span>
          </th>
          <th colspan="5" style="border: 2px solid #7e7b7b;font-size: 15px;" class="br-bottom br-top">
            Date : From {{ start_date | date: 'dd-MM-yyyy' }} - To {{ end_date | date: 'dd-MM-yyyy' }}&nbsp;&nbsp;&nbsp;
            <span><strong></strong></span>
          </th>
          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 2px solid #7e7b7b;border-top: 2px solid #7e7b7b;border-right: 2px solid #7e7b7b; font-size: 15px; text-align: center;width: 0%">
            <span><strong>दिनांक :</strong> {{today1}} </span>
            <span><strong></strong></span>
          </th>
        </tr>
        <tr>
          <th colspan="6"
            style="border: 0px solid #ffffff;border-bottom: 2px solid #7e7b7b;border-left: 2px solid #7e7b7b;font-size: 15px; text-align: center; padding: 5px;">
            <strong>अंकाचे नाव :</strong> &nbsp; {{newissuedatepp}}
          </th>
          <th colspan="5"
            style="border: 0px solid #ffffff;border-bottom: 2px solid #7e7b7b;border-left: 2px solid #7e7b7b;font-size: 15px; text-align: center; padding: 5px;">
            <strong>अंकाची दिनांक :</strong> &nbsp; {{issuedatepp | date :"dd-MM-yyy"}}
          </th>
          <th colspan="10"
            style="border: 0px solid #7e7b7b;border-bottom: 2px solid #7e7b7b;border-right: 2px solid #7e7b7b;font-size: 15px; text-align: left; padding: 5px;width:0%;">
            <strong></strong>
          </th>
        </tr>

        <tr>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">Sr
          </th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Booking<br>Date</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Booking No</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Advertiser<br>Name</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Sub<br>Category</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Customer<br>Name</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Represntive<br>Name</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Mobile<br>Number</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Office Rep<br>Name</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            RO<br>Number</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Instruction</th>

          <!-- ✅ CHECKBOX COLUMN HEADER - Before Advt. Size -->
          <th colspan="1"
            style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;text-align:center;">
            <input type="checkbox" (change)="selectAll($event)" title="Select All"
              style="width:16px;height:16px;cursor:pointer;" />
          </th>
          <th colspan="1" style="border: 2px solid #7e7b7b;width: 0%;height: 40px;font-weight: bold;font-size: 14px;">
            Advt. Size</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">Advt<br>Amt</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">Disc<br>Amt</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">Net<br>Amt</th>
          <th colspan="1" style="border:2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">Before<br>GST Amt</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">GST</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">Total<br>Amt</th>
          <th colspan="1" style="border: 2px solid #7e7b7b;width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right">जमा<br>दिनांक</th>
          <th colspan="1" style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;"
            class="br-bottom br-right amount-column">जमा</th>
          <th colspan="1"
            style="border: 2px solid #7e7b7b; width: 0%;height: 40px;font-weight: bold;font-size: 14px;text-align:center;"
            class="br-bottom amount-column">येणे<br>बाकी</th>
        </tr>
      </thead>

      <tbody *ngFor="let item of inDetailsRegReport1; let i = index">
        <tr>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:center;font-weight:bold;"
            class="br-right">{{item.advtsizeno}}</td>
          <td colspan="1" style="border:2px solid #7e7b7b; width: 0%;" class="br-right">{{item.booking_date}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;" class="br-right">{{item.booking_no}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;font-weight:bold;" class="br-right advt-name">{{
            item.advt_name | slice:0:25 }}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;font-weight:bold;" class="br-right advt-name">{{
            item.sub_category }}</td>
          <td colspan="1" style="border:2px solid #7e7b7b; width: 0%;" class="br-right">{{ item.cust_name | slice:0:10
            }}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;" class="br-right">{{item.rep_name | slice:0:13}}
          </td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;" class="br-right">{{item.rep_mob_no}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;" class="br-right">{{ item.off_rep_name |
            slice:0:13 }}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">{{item.ro_no}}
          </td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:left;" class="br-right">
            {{item.instruction | slice:0:12}}</td>

          <!-- ✅ CHECKBOX COLUMN BODY - Before Advt. Size -->
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:center;" class="br-right">
            <input type="checkbox" [(ngModel)]="item.isSelected" (change)="onCheckboxChange(item)"
              style="width:16px;height:16px;cursor:pointer;" />
          </td>

          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:left;" class="br-right">{{item.advtsize
            | slice:0:20}}</td>
          <td colspan="1" style="border:2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">{{item.advt_amt}}
          </td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">{{item.disc_amt
            | number:'1.0-0':'en-US':{'grouping':false} }}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b;width: 0%;text-align:end;" class="br-right">{{item.amount}}
          </td>
          <td colspan="1" style="border:2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">
            {{item.total_amount}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">
            {{item.totalgst}}</td>
          <td colspan="1"
            style="border: 2px solid #7e7b7b; width: 0%;text-align:end; background-color: #F7BEA2;font-weight: bold;"
            class="br-right">{{item.amount}}</td>
          <td colspan="1" style="border:2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">{{item.rcpt_date
            | slice:0:10}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">
            {{item.pymt_rcv_amt}}</td>
          <td colspan="1" style="border: 2px solid #7e7b7b; width: 0%;text-align:end;" class="br-right">
            {{item.remaingamt}}</td>
        </tr>
      </tbody>

      <tr>
        <td style="border: 2px solid #7e7b7b;font-weight: bold;text-align:center;width: 0%;">
          {{inDetailsRegReport1.length}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:center;" colspan="11">एकूण</td>
        <!-- ✅ Empty td to keep colspan alignment for checkbox column -->
        <td style="border: 2px solid #7e7b7b; width: 0%;"></td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{advtamti}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{totaldisc_total}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{totaladvtamt}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{totalbeforegst_amt}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{totalgst}}</td>
        <td
          style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;background-color: #F7BEA2;font-weight: bold;">
          {{netadvtamti}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;"></td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{jamatotalc}}</td>
        <td style="border: 2px solid #7e7b7b;font-weight: bold; width: 0%;text-align:end;">{{(netadvtamti - jamatotalc *
          1).toFixed(2)}}</td>
      </tr>
    </table>
  </div>
</div>

<div class="noPrint" style="margin-top: 2%;">
  <button mat-raised-button color="accent" 
  (click)="saveSelected()" 
  style="margin-top: 2%;"
  [disabled]="selectedItems.length === 0">
  Save Selected ({{ selectedItems.length }})
</button> 
  <button type="button" mat-raised-button matTooltip="Download Execelsheet" class="btn btn-danger"
    (click)="exportexcel('Registration Report')" style="margin-top: 2%;">
    Export
  </button>
  <button style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
    (click)="printPageA3Portrait()">
    Print
  </button>
  <button mat-dialog-close class="btn">Close</button>
</div>